import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {TeammateModel} from '../../../../../models/api/teammateModel';
import {TeammateAvatar} from '../../../../common/avatars/teammateAvatar';

/*
 * Props.
 */

export interface CellAuthorWrapperProps {
  author: TeammateModel;
  isSelected?: boolean;
}

/*
 * Style.
 */

const StyledAuthorDiv = styled.div`
  grid-area: bottom-left;
`;

const StyledContentDiv = styled.div`
  grid-area: bottom-line;
  display: flex;
  min-width: 0;
`;

/*
 * Component.
 */

export const CellAuthorWrapper: FC<PropsWithChildren<CellAuthorWrapperProps>> = (props) => (
  <>
    <StyledAuthorDiv>
      <TeammateAvatar size={VisualSizesEnum.SMALL} teammate={props.author} isSelected={props.isSelected} />
    </StyledAuthorDiv>
    <StyledContentDiv>{props.children}</StyledContentDiv>
  </>
);
